export default __webpack_public_path__ + "static/media/arrow-bold-top.0b7a3276.svg";